/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-04 14:45:16
 * @LastEditTime: 2020-09-27 09:38:56
 * @Description: 采购订单store
 */
import {
    getPurchases,
    updatePurchase,
    createPurchase,
    deletePurchase,
    getRawMaterialLatestPurchases
} from '@/api/purchase'
const state = {
    purchase: [],
    latestPurchases: [],
}

const getters = {
    getPurchaseById: (state) => (id) => {
        return state.purchase.find(x => x._id === id)
    }
}

const actions = {
    async getPurchasesAction({
        commit
    }, payload) {
        try {
            const data = await getPurchases(payload.api)
            const purchase = data.data
            commit('SETPURCHASE', purchase);
            return purchase.calcPurchaseList
        } catch (error) {
            throw error.message
        }
    },
    async getRawMaterialLatestPurchasesAction({
        commit
    }, payload) {
        try {
            const data = await getRawMaterialLatestPurchases(payload)
            const latestPurchases = data.data.materialList
            commit('SET_LATEST_PURCHASE', latestPurchases);
            return latestPurchases
        } catch (error) {
            throw error.message
        }
    },
    async createPurchaseAction({
        commit
    }, payload) {
        try {

            const newPurchase = await createPurchase(payload)

            commit('ADDNEWPURCHASE', newPurchase.data)
            return newPurchase.data
        } catch (error) {
            throw error.message
        }
    },
    async updatePurchaseAction({
        commit
    }, payload) {
        try {
            const newPurchase = await updatePurchase(payload.id, payload.data)
            return newPurchase.data
        } catch (error) {
            throw error.message
        }
    },
    async deletePurchaseAction({
        commit
    }, payload) {
        try {
            await deletePurchase(payload.id)
            commit('REMOVEPURCHASE', payload.id)
            return payload.id
        } catch (error) {
            throw error.message
        }
    }

}

const mutations = {
    SETPURCHASE(state, payload) {
        state.purchase = payload.calcPurchaseList
    },
    SET_LATEST_PURCHASE(state, payload) {
        state.latestPurchases = payload
    },
    ADDNEWPURCHASE(state, purchase) {
        purchase.concat(state.purchase)
    },

    REMOVEPURCHASE(state, purchaseId) {
        state.purchase = state.purchase.filter((e) => e._id !== purchaseId)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}